export default __webpack_public_path__ + "static/media/5.3ee7d543.jpg";